import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { PROSPECTUS_JOB_BASE_PATH } from '../../../../../../../../../features/prospectus/job/prospectus-job-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/prospectus-job/_job')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'beta-nxt-prospectus-job-list',
        label: 'BetaNXT',
        to: PROSPECTUS_JOB_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
